import React from 'react';
import VerticalDrop from '../components/VerticalDrop';
import ScrollDown from '../components/ScrollDown';
export default ({ isActive, goToNextSlide }) => {
  const message = 'Using small group trials, we follow the science to evaluate safety, identify side effects, and determine how the experimental drug should best be used.';
  
  const handleNextSlide = () => goToNextSlide();
  return (
    <div className="component hide-overflow">
      <div className="text-container text-container--higher">
        <p className="secondary-large centered">{message}</p>
      </div>
      <VerticalDrop isActive={isActive} />
      {isActive && (
        <ScrollDown text={'Now Entering Phase 2'} isWhite={true} onClickNextSlide={handleNextSlide} />
      )}
    </div>
  );
};